import { IMspCategory } from 'APIPackage/CatalogsModule/interfaces/IMspCategory';

import { IMspCategorySelectOption } from '../interfaces/IMspCategorySelectOption';

export const createMspCategorySelectOption = (mspCategory: IMspCategory): IMspCategorySelectOption => ({
  ...mspCategory,
  id: mspCategory.digitCode,
  label: mspCategory.title,
  value: mspCategory.digitCode,
});
